define('views/pages/news/view',['require','jquery','mediator','lib/utils','views/base/view','text!templates/pages/news/view.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        mediator = require('mediator'),
        utils = require('lib/utils'),
        View = require('views/base/view'),
        template = require('text!templates/pages/news/view.ejs');

    var NewsView = View.extend({
        autoRender: true,
        template: template,
        id: 'pages-news-view-page',
        className: 'page',
        region: 'main',
        events: {
            'click #voteUp': 'voteUp',
            'click #voteDown': 'voteDown',
        },
        listen: {
            'change:loading model': 'updateBreadcrumb',
            'afterLoad model': 'loaded'
        },
        loaded: function() {
            this.render();
            if (!this.model.get('Readed')) {
                this.markReaded();
            }
        },
        updateBreadcrumb: function() {
            var news = {
                name: 'news',
                action: 'news#list',
                params: {
                    tags: utils.fmtDate(this.model.get('tags'))
                },
                title: 'Новости'
            };

            mediator.setBreadcrumb([news], 'Просмотр новости');
        },
        changeVote: function(set, remove) {

            function inc($el, value) {
                var span = $el.find('span');
                span.text(parseInt(span.text(), 10) + value);
            }

            var $set = $(set);
            $set.addClass('active');
            inc($set, 1);

            var $remove = $(remove);
            if ($remove.hasClass('active')) {
                $remove.removeClass('active');
                inc($remove, -1);
            }
        },
        voteUp: function() {
            var _this = this;
            if (this.model.get('Value') > 0) { return; }
            utils.post('/page/news/up/' + this.model.get('ID'), {})
                .success(function() {
                    _this.changeVote('#voteUp', '#voteDown');
                    _this.model.set('Value', 1);
                });
        },
        voteDown: function() {
            var _this = this;
            if (this.model.get('Value') < 0) { return; }
            utils.post('/page/news/down/' + this.model.get('ID'), {})
                .success(function() {
                    _this.changeVote('#voteDown', '#voteUp');
                    _this.model.set('Value', -1);
                });
        },
        markReaded: function() {
            utils.post('/page/news/readed/' + this.model.get('ID'), {})
                .success(function() {});
        }
    });

    return NewsView;
});

